import { Axios } from 'src/lib';

import { FronteggContext } from '@frontegg/rest-api';
import {
  userInfoSlice,
  userInfoLoadingSlice,
} from '../slices/userManagement.slice';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';

export const getUserInfoAction = (orgUUID) => {
  return async (dispatch) => {
    dispatch(userInfoSlice([]));
    dispatch(userInfoLoadingSlice(true));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
      'Headless-Mode': true,
      'Impersonate-Org-UUID': orgUUID,
    };
    try {
      const result = await Axios.get(`/v2/user_management/user-info`, {
        headers,
      });
      const response = result?.data;
      if (result?.status === 200) {
        dispatch(userInfoSlice(response?.data));
      }
    } catch (error) {
      console.error('Error fetching user info:', error);
      showToastError(error?.response?.data?.message);
    } finally {
      dispatch(userInfoLoadingSlice(false));
    }
  };
};

export const resendActivationEmailAction = (orgUUID, userUUID, email) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
      'Impersonate-Org-UUID': orgUUID,
      'Headless-Mode': true,
    };
    const payload = {
      user_id: userUUID,
      email: email,
    };
    try {
      const result = await Axios.post(
        `/v2/user_management/resend-activation-email`,
        payload,
        {
          headers,
        }
      );
      if (result?.status === 200) {
        showToastSuccess('Activation email sent successfully');
      }
    } catch (error) {
      console.error('Error resending activation email:', error);
      showToastError(
        `Error resending activation email: ${error?.response?.data?.message}`
      );
    }
  };
};

export const updateFronteggRoleAction = (orgUUID, email, roleIds, callback) => {
  return async (dispatch) => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
      'Impersonate-Org-UUID': orgUUID,
      'Headless-Mode': true,
    };
    const payload = {
      user_email: email,
      role_ids: roleIds,
    };
    try {
      const result = await Axios.post(
        `/v2/user_management/assign-roles`,
        payload,
        {
          headers,
        }
      );
      if (result?.status === 200) {
        showToastSuccess('Roles assigned successfully');
        if (callback) {
          callback(true);
        }
        dispatch(getUserInfoAction(orgUUID));
      }
    } catch (error) {
      console.error('Error assigning roles:', error);
      showToastError(
        `Error assigning roles: ${error?.response?.data?.message}`
      );
      if (callback) {
        callback(false);
      }
    }
  };
};
